// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iwhl","label":"styles_label__1jLNs"};